import { decodedToken, isValidToken } from './connection-helper';
import { formatDateYearMonthDay } from './dates-helper';
var getAccountCreationDateFromToken = () => {
  if (!isValidToken()) return null;
  var token = decodedToken();
  return formatDateYearMonthDay(token.created_at);
};
export { getAccountCreationDateFromToken };